import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-filters pf-bar" }
const _hoisted_3 = { class: "pf-search" }
const _hoisted_4 = { class: "full-table" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_select_employees = _resolveComponent("select-employees")!
  const _component_add_company_sheet = _resolveComponent("add-company-sheet")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Work"),
        _createElementVNode("div", { class: "page-bar-main" }, "Spreadsheets")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[6] || (_cache[6] = _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            "aria-hidden": "true"
          }, [
            _createElementVNode("circle", {
              cx: "11",
              cy: "11",
              r: "7"
            }),
            _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQ) = $event)),
            placeholder: "Search",
            "aria-label": "Search",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search()))
          }, null, 544), [
            [_vModelText, _ctx.searchQ]
          ])
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "pf-spacer" }, null, -1)),
        (_ctx.$store.state.user.role == 'Admin')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = () => { _ctx.showAddSheet = true }),
              class: "add-btn"
            }, "Add"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sheets, (sheet, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, [
                _createVNode(_component_router_link, {
                  to: '/company-sheet/' + sheet.Slug
                }, {
                  default: _withCtx(() => [
                    (sheet.Template)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(TEMPLATE) "))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(sheet.Name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              (_ctx.$store.state.user.role == 'Admin')
                ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_ctx.editUsers(sheet.Slug)), ["prevent"])
                    }, "Edit Users", 8, _hoisted_7)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.user.role == 'Admin')
                ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                    (sheet.Name != 'Company Scorecard')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: _withModifiers(($event: any) => (_ctx.deleteSheet(sheet.Slug)), ["prevent"])
                        }, "Delete", 8, _hoisted_9))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ], 2),
    (_ctx.showEditUsers)
      ? (_openBlock(), _createBlock(_component_select_employees, {
          key: 0,
          title: "Share with",
          source: "/api/employees/picker",
          selectedIds: _ctx.editUsersCurrent,
          onSave: _ctx.saveUsers,
          onClose: _cache[3] || (_cache[3] = () => { _ctx.showEditUsers = false; })
        }, null, 8, ["selectedIds", "onSave"]))
      : _createCommentVNode("", true),
    (_ctx.showAddSheet)
      ? (_openBlock(), _createBlock(_component_add_company_sheet, {
          key: 1,
          onClose: _cache[4] || (_cache[4] = () => { _ctx.showAddSheet = false; _ctx.getSheets(); })
        }))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 2,
          onConfirm: _ctx.deleteSheetCB,
          onCancel: _cache[5] || (_cache[5] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to delete this sheet?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true)
  ]))
}